<div class="checkout-order-review">
    <div class="checkout-order-review__info">
        @if (orderNumber()) {
            <div class="heading-3">Order number: {{ orderNumber() }}</div>
        } @else {
            <div class="body-0" aria-live="polite" role="contentinfo">
                Review your order to make sure everything is correct.
            </div>
        }
        <mat-divider class="order-divider"></mat-divider>
        <div class="checkout-order-review__shipping-and-payment">
            <div>
                <h2 class="checkout-order-review__title heading-4">Shipping information</h2>
                <lib-shipping-information
                    [email]="shippingAddress()?.emailAddress"
                    [shippingAddress]="shippingAddress()"
                ></lib-shipping-information>
            </div>
            <ng-content></ng-content>
        </div>
        @if (!displayOnlyShipping()) {
            <mat-divider class="checkout-order-review__line"></mat-divider>
        }
    </div>

    @if (productCard() && !displayOnlyShipping() && isAppleBrand) {
        <div class="checkout-order-review__items" aria-live="polite" role="contentinfo">
            <div class="checkout-order-review__title">
                <h2 class="h1">Your items</h2>
            </div>
            <div class="checkout-tooltip">
                <mat-icon class="checkout-tooltip__icon" aria-hidden="true" svgIcon="ico_soft"></mat-icon>
                <p class="h1">We cannot accept returns or refunds, unless items are damaged or defective.</p>
            </div>
            <div class="items">
                @for (product of filteredProcessedProducts(); track product.lineNumber ?? product.productId) {
                    <div class="product-item-container">
                        <app-apple-care-listing-product
                            [appleCareItem]="product.appleCareItem"
                            [isOrderReview]="true"
                            [product]="product"
                            [showControls]="false"
                        >
                        </app-apple-care-listing-product>
                    </div>
                }
            </div>
            <h2 class="checkout-order-review__title h1">{{ amountLabel() }}</h2>
            <lib-cart-total-info ariaLive="off" role="contentinfo" [data]="productCard()" [totalLabel]="totalLabel()" />
        </div>

        @if (!hidePaymentDetails()) {
            <div class="checkout-order-review__payment">
                <hr class="checkout-order-review__line" />

                <h2 class="checkout-order-review__title h1">Payment details</h2>
                @if (pointsRedeem() && userService.canRedeemPoints()) {
                    <div class="checkout-order-review__row">
                        <p class="primary-cta">{{ rewardName() }} redeemed:</p>
                        <p class="checkout-order-review__row--points primary-cta">
                            {{ pointsRedeem() | number }} {{ rewardName() }}
                        </p>
                    </div>
                    <div class="checkout-order-review__row checkout-order-review__row--fit">
                        <p class="body-1">Remaining {{ rewardName() }}:</p>
                        <p class="body-1">{{ pointsAvailable() - pointsRedeem() | number }} {{ rewardName() }}</p>
                    </div>
                }
                @if (usdRedeem()) {
                    <div class="checkout-order-review__row checkout-order-review__row--billed-card billed-row">
                        <p class="billed-label">
                            <span class="primary-cta">Billed to card:</span>
                            <mat-icon
                                #tooltip2="matTooltip"
                                aria-label="Info"
                                matTooltip="Items in this order will appear on your card statement under the retailer's name."
                                matTooltipTouchGestures="on"
                                role="button"
                                svgIcon="ico_info"
                                tabindex="0"
                                [attr.aria-hidden]="false"
                                (click)="tooltip2.toggle()"
                            ></mat-icon>
                        </p>
                        <div class="billed-info">
                            <lib-partial-hidden-credit-card
                                [cardType]="cardType()"
                                [lastFourDigits]="lastFourDigits() ?? '****'"
                            ></lib-partial-hidden-credit-card>
                            <p class="checkout-order-review__row primary-cta">
                                {{ usdRedeem() | currency }}
                            </p>
                        </div>
                    </div>
                }

                @if (pointsRedeem() && usdRedeem() && userService.canRedeemPoints()) {
                    <div class="total-divider">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="checkout-order-review__row checkout-order-review__row--totals">
                        <p class="subheading-1">Total</p>
                        <lib-price-and-points
                            [points]="pointsRedeem()"
                            [price]="usdRedeem()"
                            [showBoth]="true"
                        ></lib-price-and-points>
                    </div>
                }
            </div>
        }
    } @else if (productCard() && !displayOnlyShipping()) {
        <div class="checkout-order-review__items" aria-live="polite" role="contentinfo">
            <div class="checkout-order-review__title">
                <h1 class="h1">Your items</h1>
                <mat-icon
                    #tooltip1="matTooltip"
                    matTooltipPosition="right"
                    matTooltipTouchGestures="on"
                    role="button"
                    svgIcon="ico_info"
                    tabindex="0"
                    [ariaLabel]="yourItemsLabelTooltip"
                    [attr.aria-hidden]="false"
                    [matTooltip]="yourItemsLabelTooltip"
                    (click)="tooltip1.toggle()"
                />
            </div>
            <div class="items">
                @for (product of productCard()?.products; track product.productId) {
                    <lib-cart-summary-item [product]="product"></lib-cart-summary-item>
                }
            </div>
            <h1 class="checkout-order-review__title h1">{{ amountLabel() }}</h1>
            <lib-cart-total-info ariaLive="off" role="contentinfo" [data]="productCard()" [totalLabel]="totalLabel()" />
        </div>
    }

    @if (!hideActionButton()) {
        <div class="checkout-order-review__action">
            @if (!isPlaceOrderPending()) {
                <button
                    mat-raised-button
                    class="proceed-to-payment-btn"
                    #placeOrderButton
                    (click)="submitAction.emit()"
                >
                    Place order
                </button>
            } @else {
                <div style="width: 280px; height: 48px">
                    <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
                </div>
            }
        </div>
    }
</div>
